import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import Step01 from './form/Step01'
import Step02 from './form/Step02'
import Step03 from './form/Step03'
import Step04 from './form/Step04'
import Step05 from './form/Step05'
import { alertActions, certapplyActions } from '../../../../store/actions'
import PopGetItem from './form/PopGetItem'
import history from '../../../../route/history'
import Alert from '../../../../module/alert/Alert'

const CertApply = (props) => {
  let [paramKey, setParamKey] = useState()
  let [value, setValue] = useState()
  let [step, setStep] = useState(props.match.params.step)

  /**
   * 수정정보 조회
   */
  useEffect(() => {
    let paramValue = props.location?.search?.split('=')[1]
    let paramKey = props.location?.search?.split('=')[0]

    if (paramValue !== undefined) {
      //console.log("paramValue : " + paramValue.indexOf('guBun'));
      if (paramValue.indexOf('guBun') != -1) {
        paramValue = paramValue.split('&')[0]
        paramKey && setParamKey(paramKey)
        paramValue && setValue(paramValue)
        if (paramKey === '?seq' && paramValue) {
          props.loadReapp(paramValue)
        }
      } else {
        paramValue = paramValue.split('&')[0]
        paramKey && setParamKey(paramKey)
        paramValue && setValue(paramValue)
        if (paramKey === '?seq' && paramValue) {
          props.load(paramValue)
        }
      }
    }

    // 가비지 데이터 제거
    // return () => {
    //   let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq;
    //           key && props.deleteDoc(key);
    // }
  }, [])

  /**
   * 수정정보 조회 콜백
   */
  useEffect(() => {
    if (paramKey === '?seq' && props.totalData?.step1?.docid?.length > 0) {
      //console.log("props.totalData :" + props.totalData);
      sessionStorage.setItem(props.totalData?.step1?.docid, JSON.stringify(props.totalData))
      window.location.replace('/service/certapply/1?id=' + props.totalData?.step1.docid)
    }
  }, [props.totalData])

  /**
   * 문서 삭제 콜백
   */
  useEffect(() => {
    if (props.isDelete === true) {
      sessionStorage.removeItem(value)
      props.onClear()
      window.location.replace('/service/certmng')
    }
  }, [props.isDelete])

  useEffect(() => {
    if (props.isSend === true) {
      let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq
      sessionStorage.removeItem(value)
      props.onClear()
      window.location.replace('/service/certapply/detail/' + key)
    }
  }, [props.isSend])

  /**
   * 스탭정보 세팅
   */
  useEffect(() => {
    setStep(props.match.params.step)
  }, [props.match.params.step])

  /**
   * 다음화면 진입을 위한 유효성 체크
   */
  const goStepNext = () => {
    let totalData = JSON.parse(sessionStorage.getItem(value))

    if (totalData['step' + step]?.length <= 0) {
      return props.error({ message: '목록을 등록해주세요.' })
    }

    history.push('/service/certapply/' + (parseInt(step) + 1) + '?id=' + value)
  }

  /**
   * 이전화면 진입을 위한 유효성 체크
   */
  const goStepPrev = () => {
    history.goBack()
  }

  /**
   * 문서 삭제처리
   */
  const doDelete = () => {
    //console.log('crtIssueSeq = ', JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq);
    if (paramKey === '?id' && value) {
      props.confirm({
        title: '확인',
        message: '문서를 취소하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq
            key && props.deleteDoc(key)
          },
        },
      })
    }
  }

  const doIssue = (packageId, packageCrtfNo, senderId) => {
    console.log('crtIssueSeq = ', JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq)
    console.log('props = ', props)
    console.log('packageId = ', packageId)
    console.log('packageCrtfNo = ', packageCrtfNo)
    console.log('senderId = ', senderId)

    let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq
    props.issueDoc(key, packageId, packageCrtfNo, senderId)
    /*
    props.success({
      title: '확인',
      message: '결제가 완료되었습니다.',
      params: {
        type: 'success',
        callback: () => {
          let key = JSON.parse(sessionStorage.getItem(value)).step1.crtIssueSeq;
          props.issueDoc(key,0,0);
        }
      }
    })
    */
  }

  return (
    <React.Fragment>
      <Alert />
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <h2>구매확인서 신청</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <span>증명서 신청</span>
            <em>구매확인서 신청</em>
          </div>
        </div>
        <div className="steps-box">
          <ul className="steps">
            <li className={step === '1' ? 'on' : ''}>
              <span className="num">1</span>일반정보
            </li>
            <li className={step === '2' ? 'on' : ''}>
              <span className="num">2</span>구매물품
            </li>
            <li className={step === '3' ? 'on' : ''}>
              <span className="num">3</span>수출근거 서류
            </li>
            <li className={step === '4' ? 'on' : ''}>
              <span className="num">4</span>세금계산서
            </li>
            <li className={step === '5' ? 'on' : ''}>
              <span className="num">5</span>발급신청
            </li>
          </ul>
        </div>
        {step === '1' && (
          <Step01 packageId={0} packageCrtfNo={0} passData={props.location.state} search={props.location?.search} doDelete={doDelete} />
        )}
        {step === '2' && (
          <Step02
            packageId={0}
            packageCrtfNo={0}
            passData={props.location.state}
            search={props.location?.search}
            doDelete={doDelete}
            goStepNext={goStepNext}
            goStepPrev={goStepPrev}
          />
        )}
        {step === '3' && (
          <Step03
            packageId={0}
            packageCrtfNo={0}
            passData={props.location.state}
            search={props.location?.search}
            doDelete={doDelete}
            goStepNext={goStepNext}
            goStepPrev={goStepPrev}
          />
        )}
        {step === '4' && (
          <Step04
            packageId={0}
            packageCrtfNo={0}
            passData={props.location.state}
            search={props.location?.search}
            doDelete={doDelete}
            goStepNext={goStepNext}
            goStepPrev={goStepPrev}
          />
        )}
        {step === '5' && (
          <Step05
            packageId={0}
            packageCrtfNo={0}
            passData={props.location.state}
            search={props.location?.search}
            doDelete={doDelete}
            doIssue={doIssue}
            goStepPrev={goStepPrev}
          />
        )}
      </div>
      {/* //contents */}

      {props.isShowItems === true && <PopGetItem packageId={0} packageCrtfNo={0} docid={value} />}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    totalData: state.certapply.data,
    isShowItems: state.certapply.isShowItems,
    isDelete: state.certapply.isDelete,
    isSend: state.certapply.isSend,
  }
}

const actionCreators = {
  load: certapplyActions.load,
  loadReapp: certapplyActions.loadReapp,
  error: alertActions.error,
  confirm: alertActions.confirm,
  success: alertActions.success,
  deleteDoc: certapplyActions.deleteTempDoc,
  issueDoc: certapplyActions.issueDoc,
  onClear: certapplyActions.onClear,
}

export default connect(mapStateToProps, actionCreators)(CertApply)
